import { HttpInterceptorFn, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const errorLoggerInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next) => {
  const start = Date.now();

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const duration = Date.now() - start;
      const service = resolveService(req.url);

      console.group(
        `%c[HTTP ERROR] ${req.method} ${req.url}`,
        'color:#c62828; font-weight:bold'
      );
      console.log('%cServicio detectado:', 'font-weight:bold', service);
      console.log('%cStatus:', 'font-weight:bold', err.status, err.statusText);
      console.log('%cDuración:', 'font-weight:bold', `${duration}ms`);
      if (err.error) {
        console.log('%cRespuesta del servidor:', 'font-weight:bold', err.error);
      }
      console.log('%cRequest body:', 'font-weight:bold', (req as any).body ?? '(sin body)');
      console.groupEnd();

      return throwError(() => err);
    }),
  );
};

function resolveService(url: string): string {
  const patterns: [RegExp, string][] = [
    [/diagnosticos-mantenimiento/, 'DiagnosticoMantenimientoService'],
    [/cotizaciones-refaccion/,     'CotizacionRefaccionService'],
    [/autorizaciones-compra/,      'AutorizacionCompraService'],
    [/entregas-refaccion/,         'EntregaRefaccionService'],
    [/devoluciones-piezas/,        'DevolucionPiezaUsadaService'],
    [/mantenimientos/,             'MantenimientoService'],
    [/unidades/,                   'UnidadService'],
    [/operadores/,                 'OperadorService'],
    [/tipo-mantenimientos/,        'TipoMantenimientoService'],
    [/reportes-falla/,             'ReporteFallaService'],
    [/\/auth\//,                   'AuthService'],
  ];

  for (const [pattern, name] of patterns) {
    if (pattern.test(url)) return name;
  }
  return url;
}
